import { alpha, useTheme } from "@mui/material"

import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import { NextLinkComposed } from "src/core/components/Link"
import React from "react"
import { RouteUrlObject } from "blitz"
import { Routes } from "@blitzjs/next"
import Typography from "@mui/material/Typography"
import { useCurrentUser } from "src/core/hooks/useCurrentUser"
import { useHasAnyRole } from "src/core/hooks/useHasAnyRole"
import { useRouter } from "next/router"
import { useTranslations } from "next-intl"

const NavLink = (props: {
  label: string
  href: RouteUrlObject | string
  icon?: React.ReactNode
  exact?: boolean
}) => {
  const { label, href, icon, exact } = props
  const router = useRouter()
  const theme = useTheme()
  const pathname = typeof href === "string" ? href : href.pathname
  const active = exact ? router.pathname === pathname : router.pathname.startsWith(pathname)

  return (
    <Button
      component={NextLinkComposed}
      to={href}
      fullWidth
      sx={{
        justifyContent: "flex-start",
        color: active ? undefined : "text.primary",
        bgcolor: active ? alpha(theme.palette.primary.light, 0.15) : undefined,
      }}
      startIcon={icon || null}
    >
      {label}
    </Button>
  )
}

const SidebarNav = (): JSX.Element => {
  const t = useTranslations("common")
  const hasAnyRole = useHasAnyRole()
  const user = useCurrentUser()

  return (
    <Box padding={2}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{
          fontWeight: 700,
          textTransform: "uppercase",
          marginBottom: 1,
          display: "block",
        }}
      >
        Menu
      </Typography>
      <Box marginBottom={1 / 2}>
        <NavLink href={Routes.Home()} label={t("Home")} exact />
      </Box>
      {hasAnyRole(["TEACHER", "STAFF"]) && (
        <Box marginBottom={1 / 2}>
          <NavLink href={Routes.MyIndexPage()} label={t("My Courses")} />
        </Box>
      )}
      {hasAnyRole(["TEACHER", "STAFF"]) && (
        <Box marginBottom={1 / 2}>
          <NavLink href="/course-grades" label={t("Course Grade")} />
        </Box>
      )}
      {user?.isProgramManager && (
        <Box>
          <NavLink href={Routes.ProgramManagerIndexPage()} label={t("Program Manager")} />
        </Box>
      )}
      {(user?.departmentUsers.length || hasAnyRole(["SCHOOL_MANAGER", "ADMIN"])) && (
        <Box>
          <NavLink href={Routes.AdminIndexPage()} label={t("School Manager")} />
        </Box>
      )}
    </Box>
  )
}

export default SidebarNav
